import Notification from 'components/Notification';
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { ThemeProvider } from 'styled-components/macro';
import { theme } from 'styles-global';
import { Program } from 'models/user';
import { AxiosResponse } from 'axios';
import { prefixes, prefixesNameList } from 'utils/constants';

type NotifyType = 'fail' | 'warning' | 'success';

const popupCounts = new Map<string, number>();
const notify = (type: NotifyType, message: string | Error, timeoutms = 5000, id?: string) => {
  const msg = message instanceof Error ? `${message.name}: ${message.message}` : message;
  const currid = `${id ?? Math.random()}`;
  const mount = document.getElementById('notification-portal');
  popupCounts.set(currid, (popupCounts.get(currid) ?? 0) + 1);
  const markup = ReactDOMServer.renderToString(
    <ThemeProvider theme={theme}>
      <Notification hasClose={timeoutms === 0} type={type} message={msg} count={popupCounts.get(currid)} />
    </ThemeProvider>,
  );
  if (mount) {
    const existingPopup = mount.childNodes;
    if (existingPopup.length) {
      for (const popup of existingPopup) {
        if ((popup as HTMLElement).id === currid) {
          popup.remove();
        }
      }
    }
    const newPopup = document.createElement('div');
    newPopup.id = `${currid}`;
    newPopup.innerHTML = markup;
    newPopup.onclick = () => {
      newPopup.remove();
      popupCounts.delete(currid);
    };
    mount.appendChild(newPopup);
    if (timeoutms > 0) {
      setTimeout(() => {
        newPopup.remove();
        popupCounts.delete(currid);
      }, timeoutms);
    }
  }
};

function withAbortController<P, T>(axiosApi: (apiParams: P) => Promise<AxiosResponse<T>>) {
  return (apiParams: P) => {
    if (globalThis.abortController) globalThis.abortController.abort();
    globalThis.abortController = new AbortController();
    return axiosApi(apiParams);
  };
}

const orderMenuItems = (elements: Program[]): Program[] => {
  const LucystarChildren = elements.filter(({ programType }) => programType !== -1);
  const others = elements.filter(({ programType }) => programType === -1);
  const ordered = [
    {
      idProgram: 1,
      programType: -1,
      moduleLink: '',
      module: '',
      parent: 1,
      resource: '',
      tipo: -1,
      sign: '',
      programName: 'LucyStar',
      parentProgram: 1,
      children: LucystarChildren,
      moduleApp: false,
      url: null,
    },
    ...others,
  ];
  const cleared = ordered.filter(({ children }) => children.length);
  return cleared;
};

const textTranslated = (word: string | null | undefined, t?: (label: string) => string, defaultWord?: string) => {
  if (!t || word == null) return word ?? '';
  const translated = t(word);
  return translated.search('.local') >= 0 ? defaultWord ?? word ?? '' : translated;
};

const setLocalizableString = (
  word: string | null | undefined,
  header?: string,
  prefix?: prefixesNameList,
  t?: (label: string) => string,
) => {
  if (!t || (word ?? '') === '') return word ?? '';
  const oLocalPrefix = prefixes[String(prefix) as prefixesNameList] + header?.replace(/\s/g, '');
  const OLocalWord = oLocalPrefix + `.${word}`;
  return textTranslated(OLocalWord, t);
};

export const toCamelCase = (str: string): string => {
  return str
    .toLowerCase()
    .split(' ')
    .map((word, index) => (index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)))
    .join('');
};

export default {
  notify,
  orderMenuItems,
  withAbortController,
  textTranslated,
  setLocalizableString,
  toCamelCase,
};
